<mat-card
  class="top-card mat-elevation-z0"
  *ngIf="placementInvoices.length > 0"
>
  <div
    [class]="first ? '' : 'upper-space'"
    *ngFor="
      let invoice of placementInvoices;
      let first = first;
      trackBy: trackyById
    "
  >
    <div class="form-title d-flex justify-content-between">
      <div class="form-title-text">
        Preview
        <span *ngIf="invoice.company?.regularName">
          {{ invoice.company.regularName }}</span
        >
      </div>
    </div>

    <div class="font-weight-bold secondary-color">
      Project #{{ project?.id }}
      <span *ngIf="inputProject?.projectPlacement?.address">
        -
        {{
          inputProject.projectPlacement.address.line1
            | printAddress
              : inputProject.projectPlacement.address.postalCode
              : inputProject.projectPlacement.address.city
        }}
      </span>
    </div>

    <div class="underline less-upper-space">
      <div *ngFor="let product of project.products; let i = index">
        <div class="less-upper-space" *ngIf="product.type === 'WindowSticker'">
          <div>
            <div>
              <span class="type-name">{{ product.type | productType }}</span
              ><span class="number"> #{{ i + 1 }}</span> -
              {{
                product.standardStickerParts[0]?.productSize?.height
                  | formatProductSize
                    : product.standardStickerParts[0]?.productSize?.width
              }}
            </div>
          </div>
          <div class="d-flex justify-content-between">
            <span>{{
              product.temporaryMaterial
                | formatBoolean: true:'Tijdelijk':'Permanent'
                | joiner: ' - ':product.foil?.name:product.laminate?.name
            }}</span>
            <div>
              €
              {{
                invoice.displayProductPrice?.get(product.id)?.productTotal | or
              }}
            </div>
          </div>
          <ng-container
            *ngIf="
              invoice.displayProductPrice != null &&
              invoice.displayProductPrice.get(product.id) != null
            "
          >
            <div
              class="d-flex justify-content-between"
              *ngFor="
                let line of invoice.displayProductPrice.get(product.id).prices
              "
            >
              <span>{{ line.reason }}</span>
              <span>€ {{ line.price }}</span>
            </div>
          </ng-container>
        </div>

        <div
          class="less-upper-space"
          *ngIf="product.type === 'CustomWindowSticker'"
        >
          <div>
            <div>
              <span class="type-name">{{ product.type | productType }}</span
              ><span class="number"> #{{ i + 1 }}</span> -
              {{
                product.stickerParts == null ? '0' : product.stickerParts.length
              }}
              stickers
            </div>
          </div>
          <div class="d-flex justify-content-between">
            <span>{{
              product.temporaryMaterial
                | formatBoolean: true:'Tijdelijk':'Permanent'
                | joiner: ' - ':product.foil?.name:product.laminate?.name
            }}</span>
            <div>
              €
              {{
                invoice.displayProductPrice?.get(product.id)?.productTotal | or
              }}
            </div>
          </div>
          <ng-container
            *ngIf="
              invoice.displayProductPrice != null &&
              invoice.displayProductPrice.get(product.id) != null
            "
          >
            <div
              class="d-flex justify-content-between"
              *ngFor="
                let line of invoice.displayProductPrice.get(product.id).prices
              "
            >
              <span>{{ line.reason }}</span>
              <span>€ {{ line.price }}</span>
            </div>
          </ng-container>
        </div>

        <div class="less-upper-space" *ngIf="product.type === 'Board'">
          <ng-container
            *ngIf="
              invoice.displayBoardPartPrice?.size > 0 &&
              product.boardParts?.length > 0
            "
          >
            <div *ngFor="let part of product.boardParts">
              <ng-container
                *ngTemplateOutlet="
                  boardPartPriceDisplay;
                  context: {
                    displays: invoice.displayBoardPartPrice.get(part.id)
                  }
                "
              >
              </ng-container>
            </div>
          </ng-container>
          <div class="d-flex justify-content-between">
            <ng-container
              *ngTemplateOutlet="
                priceDisplay;
                context: {
                  label:
                    'Transportprijs' +
                    (project.products.length > 1
                      ? ' Projectbord #' + (i + 1)
                      : ''),
                  price: invoice.displayProductPrice?.get(product.id)
                    ?.boardTransportOverridePrice
                }
              "
            >
            </ng-container>
          </div>
          <div
            *ngIf="product.productPlacement?.paintedPosts"
            class="d-flex justify-content-between"
            [ngClass]="
              invoice.displayProductPrice?.get(product.id)
                ?.boardTransportOverridePrice != null
                ? 'upper-space'
                : ''
            "
          >
            <ng-container
              *ngTemplateOutlet="
                priceDisplay;
                context: {
                  label:
                    'Geschilderde palen' +
                    (project.products.length > 1
                      ? ' Projectbord #' + (i + 1)
                      : ''),
                  price: invoice.displayProductPrice?.get(product.id)
                    ?.boardPaintedPostsOverridePrice
                }
              "
            >
            </ng-container>
          </div>
          <ng-container
            *ngIf="
              invoice.displayProductPrice != null &&
              invoice.displayProductPrice.get(product.id) != null
            "
          >
            <div class="upper-space">
              <div
                class="d-flex justify-content-between"
                *ngFor="
                  let line of invoice.displayProductPrice.get(product.id).prices
                "
              >
                <span>{{ line.reason }}</span>
                <span>€ {{ line.price }}</span>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="less-upper-space" *ngIf="product.type === 'OtherProduct'">
          <div class="d-flex justify-content-between">
            <div>
              <span class="type-name">{{
                product.type | productType: product.otherProductName
              }}</span
              ><span class="number"> #{{ i + 1 }}</span>
            </div>
            <div>
              €
              {{
                invoice.displayProductPrice?.get(product.id)?.productTotal | or
              }}
            </div>
          </div>
          <div>
            <span>{{ product.height | formatProductSize: product.width }}</span>
            <span *ngIf="product.otherProductMaterial?.length > 0">
              -
              <span class="preserve-line-break inline-flex">{{
                product.otherProductMaterial
              }}</span>
            </span>
          </div>
          <ng-container
            *ngIf="
              invoice.displayProductPrice != null &&
              invoice.displayProductPrice.get(product.id) != null
            "
          >
            <div
              class="d-flex justify-content-between"
              *ngFor="
                let line of invoice.displayProductPrice.get(product.id).prices
              "
            >
              <span>{{ line.reason }}</span>
              <span>€ {{ line.price }}</span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <ng-container
      *ngTemplateOutlet="
        invoicePriceDisplay;
        context: {
          price: invoice.displaySubtotal
        }
      "
    ></ng-container>
  </div>
</mat-card>
<ng-template #boardPartPriceDisplay let-displays="displays">
  <ng-container *ngIf="displays?.length > 0">
    <div *ngFor="let display of displays" class="under-space">
      <div class="d-flex justify-content-between">
        <span class="strong">{{ display.title }}</span>
        <span
          *ngIf="display.subtitles == null || display.subtitles.length === 0"
          >€ {{ display.price | asFormatDecimal: true:2 }}</span
        >
      </div>
      <ng-container *ngIf="display.subtitles?.length > 0">
        <div
          class="d-flex justify-content-between"
          *ngFor="let subtitle of display.subtitles; let i = index"
        >
          <span>{{ subtitle }}</span>
          <span *ngIf="i === 0"
            >€ {{ display.price | asFormatDecimal: true:2 }}</span
          >
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-template>
<ng-template #priceDisplay let-label="label" let-price="price">
  <ng-container *ngIf="price != null && price > 0">
    <span class="strong">{{ label }}</span>
    <span>€ {{ price | asFormatDecimal: true:2 }}</span>
  </ng-container>
</ng-template>
<ng-template #invoicePriceDisplay let-price="price">
  <div class="total-price-container">
    <div class="total-price-display-left-space"></div>
    <div class="less-upper-space spacing-bottom total-price-display">
      <div class="d-flex justify-content-between">
        <span>Totaal excl. BTW</span>
        <span>€ {{ price | asFormatDecimal: true:2 }}</span>
      </div>

      <div class="d-flex justify-content-between">
        <div>Btw 21%</div>
        <span>€ {{ price | multiply: 0.21 | asFormatDecimal: true:2 }}</span>
      </div>

      <div class="d-flex justify-content-between">
        <span>Totaal incl. BTW</span>
        <span>€ {{ price | multiply: 1.21 | asFormatDecimal: true:2 }}</span>
      </div>

      <div class="d-flex justify-content-between">
        <span class="strong">Totaal te betalen</span>
        <span class="strong"
          >€ {{ price | multiply: 1.21 | asFormatDecimal: true:2 }}</span
        >
      </div>
    </div>
  </div>
</ng-template>
